import toast from 'react-hot-toast'
import { AxiosError } from 'axios'

import {
  Container,
  Generic,
  Pallet,
  makeGeneric,
} from 'src/api/models'
import { skuit } from 'src/services/skuit'

import { Handler, HandlerInput } from './base'
import { Action, ApplyScan } from './interface'

interface LabelPrintingHandlerInput extends HandlerInput {
  obj: Generic
}

export class LabelPrintingHandler extends Handler {
  obj: Generic
  container?: Generic

  constructor(props: LabelPrintingHandlerInput) {
    super(props)
    this.obj = props.obj
  }

  apply = ({ scanned, context, local }: ApplyScan): [Action, any | undefined] => {
    switch (scanned.object.type) {
      case Pallet.type:
      case Container.type: {
        skuit.sc.freight.shipments.pallets.retrieve(this.obj.object.guid, scanned.object.guid)
          .then((container) => {
            this.container = makeGeneric(container)
            this.notify({})
          })
          .catch((error: AxiosError) => {
            toast.error(`Invalid container. "${error.response?.data}"`)
          })
        return [Action.Invalid, undefined]
      }
    }
    return [Action.Invalid, undefined]
  }

  printed = () => {
    if (this.container) {
      skuit.sc.freight.shipments.pallets.markPrinted(this.obj.object.guid, this.container.object.guid)
    }
    this.container = undefined
    this.notify({})
  }

  getContext = () => {
    return { activity: 'label_printing', obj: this.obj.object.guid }
  }
}
